module.exports = __webpack_public_path__ + "img/download-grey.b7643c24.svg";